import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from "moment";

export const exportToExcel = async (filename, value = {}, isRaw = true) => {
  try {
    const fileName = `${filename}${moment().format('YYYYMMDD')}`;
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    let data = {};
    if (isRaw) {
      const ws = XLSX.utils.json_to_sheet(value);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      data = new Blob([excelBuffer], { type: fileType });
    } else {
      data = new Blob([value], { type: fileType });
    }
    FileSaver.saveAs(data, fileName + fileExtension);
  } catch (error) {
    console.log(error);
  }
}

export const exportToExcelfromLink = async (filename, link) => {
  try {
    const fileName = `${filename}${moment(new Date()).tz('Asia/Hong_Kong').format('YYYYMMDDHHmmss')}`;
    const fileExtension = '.xlsx';
    // fetch(link).then((response) => {
    //   response.blob().then((blob) => {
    //     var blob = new Blob(blob, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
    //     FileSaver.saveAs(blob, fileName + fileExtension);
    //   }) 
    // })
    FileSaver.saveAs(link, fileName + fileExtension);
  } catch (error) {
    console.log(error);
  }
}